export const RUNTIME_CONFIG_PATH = "/vida-cloud-currents-config.json";

export type RuntimeConfig = {
  appsyncEndpoint: string;
  appsyncRealtimeEndpoint?: string;
  adminApiUrl?: string;
  cognitoDomain: string;
  cognitoClientId: string;
  oauthRedirectUri: string;
  oauthPostLogoutRedirectUri?: string;
  sessionBrokerUrl?: string;
  loginUrl?: string;
  publicBaseUrl?: string;
};

let runtime: RuntimeConfig | null = null;

function fromEnv(key: string): string {
  const raw = import.meta.env as Record<string, string | undefined>;
  return typeof raw[key] === "string" ? raw[key]!.trim() : "";
}

export async function ensureConfig(): Promise<void> {
  if (import.meta.env.DEV) return;
  if (runtime) return;
  const res = await fetch(RUNTIME_CONFIG_PATH, { cache: "no-store" });
  if (res.ok) {
    runtime = (await res.json()) as RuntimeConfig;
    return;
  }
  if (
    fromEnv("VITE_APPSYNC_ENDPOINT") &&
    fromEnv("VITE_ADMIN_API_URL") &&
    fromEnv("VITE_COGNITO_DOMAIN") &&
    fromEnv("VITE_COGNITO_CLIENT_ID") &&
    fromEnv("VITE_OAUTH_REDIRECT_URI")
  ) {
    return;
  }
  throw new Error(`Config mancante: serve ${RUNTIME_CONFIG_PATH} o variabili VITE_*.`);
}

export function getAdminApiUrl(): string {
  return (runtime?.adminApiUrl?.trim() || fromEnv("VITE_ADMIN_API_URL")).replace(/\/$/, "");
}

export function getAppsyncEndpoint(): string {
  return (runtime?.appsyncEndpoint?.trim() || fromEnv("VITE_APPSYNC_ENDPOINT")).replace(/\/$/, "");
}

export function getCognitoDomain(): string {
  return (runtime?.cognitoDomain?.trim() || fromEnv("VITE_COGNITO_DOMAIN")).replace(/\/$/, "");
}

export function getClientId(): string {
  return runtime?.cognitoClientId?.trim() || fromEnv("VITE_COGNITO_CLIENT_ID");
}

export function getRedirectUri(): string {
  return runtime?.oauthRedirectUri?.trim() || fromEnv("VITE_OAUTH_REDIRECT_URI");
}

export function getSessionBrokerUrl(): string {
  return runtime?.sessionBrokerUrl?.trim() || fromEnv("VITE_SESSION_BROKER_URL");
}

export function getLoginUrl(): string {
  return runtime?.loginUrl?.trim() || fromEnv("VITE_LOGIN_URL");
}

export function getPostLogoutRedirect(): string {
  const login = getLoginUrl();
  if (login) return `${login.replace(/\/$/, "")}/login`;
  const fromRuntime = runtime?.oauthPostLogoutRedirectUri?.trim();
  if (fromRuntime) return fromRuntime;
  const envLogout = fromEnv("VITE_OAUTH_POST_LOGOUT_REDIRECT");
  if (envLogout) return envLogout;
  return "https://login.oceany.ai/login";
}

export function isConfigured(): boolean {
  return Boolean(
    getAppsyncEndpoint() &&
      getAdminApiUrl() &&
      getCognitoDomain() &&
      getClientId(),
  );
}
